import {
  Button,
  Card,
  Divider,
  Form,
  Input,
  Typography,
  message,
} from "antd";
import { useEffect, useState } from "react";
import "../styles/index.css";
import { Link } from "react-router-dom";
import { IndianRupee } from "lucide-react";
import { AndhraApiService } from "../httpsservice/ApiService";

const { Text } = Typography;

const BillCard = ({ billData }) => {
  const [form] = Form.useForm();
  const [payableAmount, setPayableAmount] = useState("");
  const [formattedAmount, setFormattedAmount] = useState("");
  const [reviewButton, setReviewButton] = useState(true);
  const [mandatoryAmount, setMandatoryAmount] = useState(false);
  const [isPayloading, setPayLoader] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (billData) {
      if (
        billData.OPNBAL + billData.ACD + billData.NETAMT + billData.RCFEE >
        0
      ) {
        setPayableAmount(
          billData.OPNBAL + billData.ACD + billData.NETAMT + billData.RCFEE
        );
        setFormattedAmount(
          billData.OPNBAL + billData.ACD + billData.NETAMT + billData.RCFEE
        );
        setMandatoryAmount(true);
        setReviewButton(false);
      } else {
        setPayableAmount("");
        setFormattedAmount("");
        setMandatoryAmount(false);
        setReviewButton(true);
      }
    }
  }, [billData]);

  const handleAmountChange = (e) => {
    let amount = e.target.value.replace(/\D/g, "");
    setPayableAmount(amount);
    setFormattedAmount(amount);
  };

  const handlePayment = () => {
    form
      .validateFields()
      .then(() => {
        if (
          !payableAmount ||
          payableAmount.trim() === "" ||
          isNaN(payableAmount) ||
          Number(payableAmount) <= 0
        ) {
          messageApi.error("Please enter a valid payable amount!");
          return;
        }
        if (formattedAmount) {
          setReviewButton(false);
          setMandatoryAmount(true);
        }
      })
      .catch((error) => {
        console.error("Validation Failed:", error);
      });
  };

  const pay = async () => {
    setPayLoader(true);
    const queryData = {
      txn_id: billData?.TXNID,
      amount: payableAmount,
    };
    const response = await AndhraApiService.payBill(queryData);
    if (response.success) {
      window.location.href = response.redirect_url;
    } else {
      window.location.href = "/APCPDCL/Billpay";
    }
    setPayLoader(false);
  };

  const handelBackPress = () => {
    if (mandatoryAmount) {
      window.location.href = "/APCPDCL/Billpay";
      return;
    }
    if (reviewButton) {
      window.location.href = "/APCPDCL/Billpay";
    } else {
      setReviewButton(true);
      setFormattedAmount("");
    }
  };

  return (
    <div className="bill">
      {contextHolder}
      <Card className="service-number-card-internal">
        <div className="logo-main">
          <img
            alt="BSES"
            className="bses-logo"
            src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/cpdcl_logo.svg"
          />
          <img
            alt="Bank Logo"
            className="bob-logo"
            src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Federal_bank.svg"
          />
        </div>

        <div className="table-main">
          <p className="table-head">
            {!reviewButton ? "Review Bill Details" : "Bill Details"}
          </p>
          <table className="table ">
            <tbody>
              <tr>
                <td>Service Number</td>
                <td>{billData?.SERVICENO || "N/A"}</td>
              </tr>
              <tr>
                <td>Service Type</td>
                <td>{billData?.SCTYPE || "N/A"}</td>
              </tr>
              <tr>
                <td>Customer Name</td>
                <td>{billData?.CNAME || "0.00"}</td>
              </tr>
              <tr>
                <td>Circle Name</td>
                <td>{billData?.CITY || "N/A"}</td>
              </tr>
              <tr>
                <td>ERO Code</td>
                <td>{billData?.EROCD || "N/A"}</td>
              </tr>
              <tr>
                <td>Arrear amount</td>
                <td>
                  Rs.{" "}
                  {billData?.OPNBAL
                    ? parseFloat(billData?.OPNBAL).toFixed(2)
                    : "0.00"}
                </td>
              </tr>
              <tr>
                <td>Current Demand</td>
                <td>
                  Rs.{" "}
                  {billData?.NETAMT
                    ? parseFloat(billData?.NETAMT).toFixed(2)
                    : "0.00"}
                </td>
              </tr>
              <tr>
                <td>ACD Amount</td>
                <td>
                  Rs.{" "}
                  {billData?.ACD
                    ? parseFloat(billData?.ACD).toFixed(2)
                    : "0.00"}
                </td>
              </tr>
              <tr>
                <td>Reconnection Fees</td>
                <td>
                  Rs.{" "}
                  {billData?.RCFEE
                    ? parseFloat(billData?.RCFEE).toFixed(2)
                    : "0.00"}
                </td>
              </tr>
              <tr>
                <td>Bill Date</td>
                <td>{billData?.BILLDATE || "N/A"}</td>
              </tr>
              <tr>
                <td>Due Date</td>
                <td>{billData?.DUEDATE || "N/A"}</td>
              </tr>
              <tr>
                <td>Disconnection Date</td>
                <td>{billData?.DISCDATE || "N/A"}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {formattedAmount && (
          <table className="table payment-amt">
            <tbody>
              <tr>
                <td> Payment Amount</td>
                <td>Rs. {parseFloat(formattedAmount).toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        )}
        {reviewButton && (
          <>
            <div className="amount-input-container">
              <label className="amount-label">
                Payable Amount <span style={{ color: "red" }}>*</span>
              </label>
              <div className="amount-input-wrapper">
                <IndianRupee className="rupee-icon" size={14} />
                <Input
                  type="text"
                  placeholder="Enter Amount"
                  value={payableAmount}
                  onChange={handleAmountChange}
                  className="amount-input"
                />
              </div>
            </div>
          </>
        )}
        {!reviewButton && mandatoryAmount ? (
          <Button
            className="fetch-bill-btn"
            size="large"
            block
            onClick={pay}
            loading={isPayloading}
          >
            Pay Rs. {formattedAmount}
          </Button>
        ) : (
          <>
            <Button
              className="fetch-bill-btn"
              size="large"
              block
              onClick={handlePayment}
            >
              Review Details
            </Button>
          </>
        )}
        <Link
          className="back-bill-btn"
          size="large"
          type="link"
          block
          onClick={handelBackPress}
        >
          Back
        </Link>
        <div className="dividercalss">
          <Divider></Divider>
        </div>
        <p className="charges-title">Charge for Payment per Transaction</p>
        <ul className="charges-list">
          <li>1. Net Banking - Rs. 2.50</li>
          <li>2. Credit Card - 0.80%</li>
          <li>3. Debit Card below Rs. 2000 - 0.40%</li>
          <li>4. Debit Card above Rs. 2000 - 0.90%</li>
          <li>5. Debit Card RuPay – Nil</li>
          <li>6. UPI - Nil</li>
          <li>* Excluding GST</li>
        </ul>
      </Card>
    </div>
  );
};

export default BillCard;